/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Goal_MobilityInputs */

const en_portal_goal_mobility = /** @type {(inputs: Portal_Goal_MobilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobility`)
};

const pl_portal_goal_mobility = /** @type {(inputs: Portal_Goal_MobilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobilność`)
};

/**
* | output |
* | --- |
* | "Mobility" |
*
* @param {Portal_Goal_MobilityInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_goal_mobility = /** @type {((inputs?: Portal_Goal_MobilityInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Goal_MobilityInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_goal_mobility(inputs)
	return en_portal_goal_mobility(inputs)
});